import { render, staticRenderFns } from "./FHeaderDetail.vue?vue&type=template&id=39d32650&scoped=true&style=min-width%3A%201920px%3B&"
import script from "./FHeaderDetail.vue?vue&type=script&lang=js&"
export * from "./FHeaderDetail.vue?vue&type=script&lang=js&"
import style1 from "./FHeaderDetail.vue?vue&type=style&index=1&id=39d32650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d32650",
  null
  
)

export default component.exports